import { FormattedMessage } from 'react-intl'
import { Divider } from '@mui/material'

import UserAction from './UserAction'

// Logout
import LogoutIcon from 'assets/icons/icon-action-logout.svg?react'
import HomeIcon from 'assets/icons/icon-action-home.svg?react'

import { useNavigate } from 'react-router-dom'
import useAuthenticationLogout from 'app/ui/useAuthenticationLogout'

export default function UserActions({ showWorkspaceButton }: { showWorkspaceButton?: boolean }) {
  const navigate = useNavigate()
  const { logout } = useAuthenticationLogout()

  const handleLogout = () => {
    logout()
  }

  return (
    <>
      {showWorkspaceButton && (
        <>
          <Divider />
          <UserAction
            icon={<HomeIcon />}
            text={<FormattedMessage id="common.workspace" />}
            onClick={() => navigate('/')}
          />
        </>
      )}
      <Divider />
      <UserAction
        icon={<LogoutIcon />}
        text={<FormattedMessage id="common.logout.logoutButton" />}
        color="error"
        onClick={handleLogout}
      />
    </>
  )
}
